import { IProductInfo } from "@protoplan/types";

export function enforceProductTypes(products: IProductInfo[])
{
  return products.map(p => ({
    ...p,
    deliverableListingsForUser: Boolean(p.deliverableListingsForUser),
    amount: Number(p.amount) }));
}
